import { useEffect, useState } from 'react'

/** This hook facilitates the internal management of focus and touched states for fields. This is useful when the fields are not used under a form manager.
 * If touched and/or focus states are provided the hook will give precence to them and will not manage them
 */
const useInternalState = ({
  focus,
  touched,
  inputProps
}) => {
  const [internalFocus, setInternalFocus] = useState(focus),
    [internalTouched, setInternalTouched] = useState(touched),
    internalInputProps = {...inputProps}

  if (focus === null) {
    internalInputProps.onFocus = (...args) => {
      setInternalFocus(true)

      if (inputProps.onFocus) {
        inputProps.onFocus(...args)
      }
    }

    internalInputProps.onBlur = (...args) => {
      setInternalFocus(false)
      if (inputProps.onBlur) {
        inputProps.onBlur(...args)
      }
    }
  }

  if (touched === null) {
    internalInputProps.onBlur = (...args) => {
      setInternalTouched(true)

      if (inputProps.onBlur) {
        inputProps.onBlur(...args)
      }
    }
  }

  useEffect(() => {
    setInternalFocus(focus)
  }, [focus])

  useEffect(() => {
    setInternalTouched(touched)
  }, [touched])

  return {
    internalFocus,
    internalTouched,
    internalInputProps
  }
}

export default useInternalState
